module.exports = __webpack_public_path__ + "img/drone-with-package.b5c016d5.svg";